import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

export const langHeaderInterceptor: HttpInterceptorFn = (req, next) => {
    if (!req.url.includes('/api/')) {
        return next(req);
    }

    const t = inject(TranslateService);
    const lang = t.getCurrentLang() || t.getFallbackLang() || 'en';

    const cloned = req.clone({
        setHeaders: { 'Accept-Language': lang }
    });

    return next(cloned);
};
